import './promotion-bar.scss';

class PromotionBar {
    constructor (element, options) {
        // Defaults & Settings
        const defaults = {
            initAttr: 'data-promotionbar',
            activeAttr: 'data-promotionbar-active',
            idAttr: 'data-promotionbar-id',
            liveRegionVisibleAttr: 'data-promotionbar-visible',
            liveRegionInvisibleAttr: 'data-promotionbar-invisible',
            closeValue: 'close',
            liveRegionValue: 'live-region'
        };

        this.settings = Object.assign({}, defaults, options);

        // Elements
        this.$root = element;
        this.$close = this.$root.querySelector(`[${this.settings.initAttr}="${this.settings.closeValue}"]`);
        this.$relatedLiveRegion = document.querySelector(`[${this.settings.initAttr}="${this.settings.liveRegionValue}"]`);

        // Properties
        this.active = false;
        this.id = this.$root.getAttribute(this.settings.idAttr);
        this.enabled = this.getAllowedStateFromStorage();
    }

    initialize () {
        this.toggleVisibility();
        this.setEvents();

        window.eventScroller.customFunctions.push(() => {
            this.toggleVisibility();
        });
    }

    getAllowedStateFromStorage() {
        const storedAllowed = sessionStorage.getItem(`promotionbar_${this.id}`);
        return storedAllowed === 'false' ? false : true;
    }

    setAllowedStateToStorage() {
        sessionStorage.setItem(`promotionbar_${this.id}`, this.enabled.toString());
    }

    updateState (active) {
        this.active = active;
        this.$root.setAttribute(this.settings.activeAttr, this.active);

        if (!this.enabled) {
            this.$root.setAttribute('aria-hidden', true);
        }

        if (this.$relatedLiveRegion ) {
            const text = this.active? this.$relatedLiveRegion.getAttribute(this.settings.liveRegionVisibleAttr) : this.$relatedLiveRegion.getAttribute(this.settings.liveRegionInvisibleAttr);
            if (text !== null) {
                this.$relatedLiveRegion.textContent = text;
            }
        }
    }

    toggleVisibility() {
        const scrollPosition = window.scrollY;
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;

        if (!this.enabled) {
            this.$root.setAttribute('aria-hidden', true);
        }

        if (scrollPosition >= windowHeight * 0.5 && documentHeight - scrollPosition > windowHeight * 1.5) {
            if (!this.active && this.enabled) this.updateState(true);
        } else {
            if (this.active && this.enabled) this.updateState(false);
        }
    }

    setEvents () {
        this.$close?.addEventListener('click', () => {
            if (this.enabled && this.active) {
                this.enabled = false;
                this.setAllowedStateToStorage();
                this.updateState(false);
            }
        });
    }
}

export { PromotionBar };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-promotionbar="root"]');
        $$roots.forEach($root => {
            const $rootAPI = new PromotionBar($root);
            $rootAPI.initialize();
        });
    }
});
